import key from 'weak-key';

// styles
import styles from '../detail.module.scss';

// types
import type { AddressItem } from '../../Sidebar/Sidebar.types';

// components
import { AddressDetail } from './address-detail';
import { ContactDetail } from './contact-detail';
import { WebDetail } from './web-detail';
import { AccWrapper } from './acc-wrapper';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';
import { useTranslationByKey } from 'utils/hooks/use-translations';
import { isEmpty } from 'utils/is-empty';

type ShowroomDetailProps = {
  item: AddressItem;
  detailLayer: string;
  openAcc?: boolean;
  isAcc?: boolean;
  isNord?: boolean;
};

export function ShowroomDetail({
  item: { name, address, fax, phone, email, website, zip, city, products },
  detailLayer,
  openAcc = false,
  isAcc = false,
  isNord = false,
}: Readonly<ShowroomDetailProps>) {
  const translationLocatorProducts = useTranslationByKey('web20_locator_products');
  const nordStyle = isNord && styles.nord;

  return (
    <AccWrapper isAcc={isAcc} isNord={isNord} openAcc={openAcc}>
      <div className={classNameBuilder(styles.locatorDetail, nordStyle)}>
        <ul>
          {!isEmpty(detailLayer) && !isEmpty(name) && (
            <li>
              <InnerHtml as="b" content={name} />
            </li>
          )}
          <AddressDetail isAcc={isAcc} isNord={isNord} zip={zip} city={city} address={address} />
          <ContactDetail phone={phone} fax={fax} />
        </ul>
        <WebDetail email={email} website={website} isNord={isNord} />
        {!(isAcc && isNord) && products && !isEmpty(translationLocatorProducts) && (
          <InnerHtml
            as={isNord ? 'h6' : 'b'}
            className={classNameBuilder(styles.showroomHeadline, nordStyle)}
            content={translationLocatorProducts}
          />
        )}
      </div>
      <div className={classNameBuilder(styles.showroomDetails, nordStyle)}>
        {!(isAcc && isNord) &&
          products?.map((product) => (
            <div className={classNameBuilder(styles.categoryList, nordStyle)} key={key(product)}>
              <InnerHtml as="b" content={product.category} />
              {product.series.map((serie) => (
                <span key={serie}>{serie}</span>
              ))}
            </div>
          ))}
      </div>
    </AccWrapper>
  );
}
